import { StorageState } from '../../../reducers';
import { createDataFetchSliceSelectors } from '../../../utils/dataFetch';


export const adminAccountServicesDictionarySliceSelector = (state: StorageState) => state.adminAccount.servicesDictionary;

export const adminAccountServicesDictionarySelectors = createDataFetchSliceSelectors(
    adminAccountServicesDictionarySliceSelector
);
